import React from 'react';
import { Alert } from 'react-bootstrap';

const NoData = ({ type }) => {
  return (
    <div style={{ width: '100%' }}>
      <Alert style={{ 
        margin: '1rem 0', 
        marginBottom: 0,
        fontSize: '16px',
        backgroundColor: 'var(--primary-color-semitransparent3)',
        border: '1px solid var(--primary-dark-color)',
        color: '#333',
        borderRadius: '0 0 8px 8px',
        textAlign: 'center'
      }}>
        <h5 style={{ marginBottom: '10px', color: 'var(--primary-light-color)' }}>No Results</h5>
        <p style={{ marginBottom: 0 }}>No {type} found matching your criteria. Try adjusting your filters.</p>
      </Alert>
    </div>
  );
};

export default NoData;
